import Names from "../Models/common/Names";

export function getFullName<T extends Names>(names: T): string {
  return [names.firstName, names.lastName].filter((n) => !!n).join(" ");
}
